import { UsersService } from "@/services/usersService";
import { useMemo } from "react";

import { useAPI } from "./useAPI";

export const useUserService = () => {
  const api = useAPI("v2");
  return useMemo(() => new UsersService(api), [api]);
};
